<template>
	<ul class="accordion">
		<slot></slot>
	</ul>
</template>

<script>
// Based on:
// https://codesandbox.io/s/yvq8z580qv?file=/src/App.vue:32-2059
// TO DO: Allow to set array as open index list
// TO DO: Emmit all kind of garbage

export default {
	props: {
		openIndex: {
			type: Number,
			default: -1, // -1 is for none
		},
		multiple: {
			// allow multiple to open
			type: Boolean,
			default: false,
		},
	},

	data() {
		const VM = this
		return {
			Accordion: {
				allowMultiple: VM.multiple,
				count: 0,
				active: VM.openIndex === -1 ? null : VM.openIndex,
			},
		}
	},
	provide() {
		return { Accordion: this.Accordion }
	},
}
</script>

<style lang="scss" scoped>
.accordion {
	list-style: none;
	margin: 0;
	padding: 0;
}
</style>
